import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

export function TextareaValue({ deal, fields, label, name, value }) {
  value = value == null ? deal[name] : value;

  if (!value || !fields[name] || fields[name].hidden) {
    return null;
  }

  return (
    <tr>
      <th className="bg-transparent py-1 px-0">{label || fields[name].label}</th>
      <td className="bg-transparent py-1 px-0"><div className="overview-textarea">{value}</div></td>
    </tr>
  );
}

TextareaValue.propTypes = {
  deal: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
};

const mapStateToProps = state => ({
  deal: state.deal,
  fields: state.fields,
});

export default connect(mapStateToProps)(TextareaValue);
